<script>
let { width = 2.5 , checked = true, id = "toggle" , disabled = false } = $props();
let padding = $derived(width * .1);
let trackWidth = $derived( width * 2 + padding * 4 );
let trackHeight = $derived( width + padding * 2 );
let trackRadius = $derived( trackHeight / 2 );
let knobRadius = $derived( width / 2 )
let knobOffset = $derived(trackWidth / 2 );

</script>

<label for={id} class="toggle-wrapper">
    <input 
        id={id}
        class="switch"
        disabled={disabled}
        type="checkbox"
        role="switch"
        aria-checked={checked}
        bind:checked={checked}
        >

    <div 
        class="track" 
        style="
            width: {trackWidth}rem;
            height: {trackHeight}rem; 
            padding: {padding}rem;
            border-radius: {trackRadius}rem;
        "
        >
        <div 
            class={["knob"]} 
            style="
                width: {width}rem; 
                height: {width}rem;
                border-radius: {knobRadius}rem;
                transform: translateX({checked ? knobOffset : 0}rem);
                "></div>

    </div>
</label>

<style>
.toggle-wrapper {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
}

/* Hide default HTML checkbox */
.toggle-wrapper input {
    pointer-events: none;
    position: absolute;
    opacity: 0;
    width: 0;
    height: 0;
}

/* The track */
.track {
    display: flex;
    align-items: center;
    background-color: #929292;
    transition: all .3s ease;
}

.knob {
    background-color: black;
    transition: transform 0.25s cubic-bezier(.25,.8,.25,1),
	            background-color 0.25s ease;
}

input:checked + .track {
    background-color: #34FF8C;
}

/* Keyboard focus (real accessibility) */
.toggle-wrapper input:focus-visible + .track {
	outline: 2px solid #4DA3FF;
	outline-offset: 2px;
	border-radius: inherit;
}

.switch:disabled {
    pointer-events: none;
    cursor: not-allowed;
}

.switch:disabled .knob {
    transition: none;
}

</style>